<template>
  <template v-if="props.modelValue && Object.keys(props.modelValue).length">
    <ul>
      <li v-if="props.modelValue.survey_option_selected">
        Survey Option: {{ props.modelValue.survey_option_selected }}
      </li>
      <li
        v-if="props.modelValue.prompt_id"
        :title="props.modelValue.prompt_id"
        class="inline-flex flex-col"
      >
        <span v-if="prompt?.id">
          Prompt name:
          <RouterLink :to="getPromptLink(prompt?.id, route.params.aid)">
            {{ prompt?.name }}
          </RouterLink>
        </span>
        <span>Prompt ID: {{ props.modelValue.prompt_id }}</span>
      </li>
      <li v-for="(value, key) in args" :key="key">
        {{ `${key}: ${value}` }}
      </li>
      <li v-if="hasRedirectDelay">
        A {{ props.redirectDelaySeconds }}s delay applies to this redirect
      </li>
    </ul>
  </template>
  <template v-else-if="hasRedirectDelay">
    A {{ props.redirectDelaySeconds }}s delay applies to this redirect
  </template>
  <template v-else> No Arguments </template>
</template>

<script setup>
import ApiPaths from "@/apis/ApiPaths";
import { useAllPromptsStore } from "@/pinia/allPromptsStore";
import { getPromptLink } from "@/utils/getLink";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

const allPromptsStore = useAllPromptsStore();

const prompt = ref();
const route = useRoute();

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
  redirectDelaySeconds: { type: [Number, String], default: null },
});

const hasRedirectDelay = computed(() => Number(props.redirectDelaySeconds) > 0);

const getPrompt = async () => {
  if (!props.modelValue?.prompt_id) return;
  if (allPromptsStore.prompts?.length) {
    const foundPrompt = allPromptsStore.prompts.find(p => p.id === props.modelValue.prompt_id);
    if (foundPrompt) {
      prompt.value = foundPrompt;
    }
  }
  try {
    if (!prompt.value || prompt.value?.id !== props.modelValue.prompt_id) {
      prompt.value = await ApiPaths.getPath(route.params.aid, props.modelValue.prompt_id);
    }
  } catch (_e) {
    prompt.value = { name: "Prompt not found", id: null };
  }
};

onMounted(getPrompt);
watch(() => props.modelValue?.prompt_id, getPrompt);

const args = computed(() => {
  if (!props.modelValue) return {};
  const copyObj = { ...props.modelValue };
  delete copyObj.survey_option_selected;
  delete copyObj.prompt_id;
  return copyObj;
});
</script>
